<template>
	<v-card rounded class="opaqueBg02">
		<v-card-text>
			<h2 class="text-h4">{{ title }} File Collections</h2>
		</v-card-text>
		<v-card-text class="pt-0">
			<v-card rounded class="opaqueBg">
				<v-list-item-group>
					<CollectionItem
						v-for="c in collections"
						:key="c"
						@click.native="$emit('show', c)"
						:title="calculateTitle(c)"
					/>
				</v-list-item-group>
			</v-card>
			<!-- :form="formComponent" -->
		</v-card-text>
	</v-card>
</template>

<script>
import Collection from '@/components/admin/FileItemCollection'
import CollectionItem from './n-items/CollectionItem'

export default {
	name: 'CollectionList',
	props: {
		title: String,
		collections: Array,
	},
	components: {
		Collection,
		CollectionItem,
	},
	methods: {

		calculateTitle(title){
			const titleRegex = /.+(\/.+)$/
			let returnedTitle = title
			titleRegex.test(title) ? returnedTitle = title.match(titleRegex)[1].substring(1) : ''
			return returnedTitle
		}
	}
}
</script>